(function GroupManageProposal($, Adzuki)
{
	"use strict";

	Adzuki.onload(['Groups/manageProposals'], init, false);

	function init()
	{
		$('.stats').click(function showStats(e) {
			var $self       = $(this),
				$modal      = $(".modal"),
				proposal_id = $self.data("id");

			e.preventDefault();

			// $modal.addClass('wide');
			$modal.find('.modal-body').text('Loading proposal stats...');

			Adzuki.Ajax.get('/Groups/proposalStats/' + proposal_id)
				.then(function _showExcursions(html) {
					$modal.find('.modal-body').html(html);
					$modal.find('[data-toggle^="tooltip"]').tooltip();
			});

			$modal.find('.modal-title').text('Proposal Stats');
			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		});
	}

}(jQuery, window.Adzuki || {}));